console.log("B2B hooks")
window.bssB2BHooks = window.bssB2BHooks || {
    actions: {},
    filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, callback) => {
    window.bssB2BHooks.actions[tag] = callback;
}
window.BSS_B2B.addFilter = (tag,  value) => {
    window.bssB2BHooks.filters[tag] = value;
}
function handleQuickviewWithTD({appliedDisplayRule,Tax, BSS_B2B, shopData}) {
  if (!BSS_B2B.page.isProductPage()) {
    const mutationObserver = new MutationObserver(() => {
      const a = document.querySelector("modal-dialog, product-recommendations");
      if (a) {
        setTimeout(() => {
        Tax.showProductPriceIncludedVat(BSS_B2B, shopData);
        }, 1000)
      }
    });
    mutationObserver.observe(document.body,{ attributes: true, childList: true });
  }
  else{
     let interval = setInterval(()=>{
        const a = document.querySelector("product-recommendations:has(.container)");
        if (a) {
          Tax.bssB2BChangeCollectionItemVatPriceWithoutCP(shopData, appliedDisplayRule);
          clearInterval(interval)
        }
      }, 1000)
    };
  }
window.BSS_B2B.addAction('handle_quickview_with_TD', handleQuickviewWithTD);
